import axios from 'axios'

const nobuService = {
  generateVA: ({ virtualAccountName, orderId, value }) => {
    // Format value to include .00 at the end
    const formattedValue = value.toString().includes('.') ? value : `${value}.00`
    
    return axios.post('/nobu/generate-va', {
      virtualAccountName,
      orderId,
      value: formattedValue
    })
  }
}

export default nobuService
